"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var startsWith = require("lodash.startswith");
var endsWith = require("lodash.endswith");
// Exported Functions
exports.canonicalizeBaseUrl = function (baseUrl) {
    var nonNullUrl = baseUrl || '';
    return endsWith(nonNullUrl, '/') ? nonNullUrl.substr(0, nonNullUrl.length - 1) : baseUrl;
};
exports.canonicalizeRelativeUrl = function (relativeUrl) {
    var nonNullUrl = relativeUrl || '';
    return startsWith(nonNullUrl, '/') ? relativeUrl : '/' + nonNullUrl;
};
exports.combine = function (baseUrl, relativeUrl) {
    var newBaseUrl = exports.canonicalizeBaseUrl(baseUrl) || '';
    return newBaseUrl + exports.canonicalizeRelativeUrl(relativeUrl);
};
exports.canonicalizeProtocol = function (protocol) {
    if (protocol) {
        return endsWith(protocol, '://') ? protocol : protocol + '://';
    }
    else {
        return protocol;
    }
};
exports.buildHostUrl = function (protocol, host, port) {
    var hostAndPort = host + (port ? ':' + port : '');
    return exports.canonicalizeProtocol(protocol) + hostAndPort;
};
exports.combineUrlAndQueryString = function (url, queryString) {
    var simpleUrl = exports.canonicalizeBaseUrl(url);
    return queryString ? simpleUrl + "?" + queryString : simpleUrl;
};
exports.buildFromConfig = function (configObj, relativeUrl, queryString) {
    var hostUrl = exports.buildHostUrl(configObj.protocol, configObj.host, configObj.port);
    var baseUrl = exports.combine(hostUrl, configObj.base);
    var url = exports.combine(baseUrl, relativeUrl);
    return exports.combineUrlAndQueryString(url, queryString);
};
exports.paramsToQueryString = function (params) {
    var result = '';
    for (var key in params) {
        var value = params[key];
        if (result !== '') {
            result += '&';
        }
        if (value === null) {
            result += key;
        }
        else {
            result += key + "=" + encodeURIComponent(value);
        }
    }
    return result;
};
exports.canonicalizeQueryString = function (queryString) {
    return startsWith(queryString, '?') ? queryString.substr(1) : queryString;
};
exports.canonicalizePath = function (path) {
    return endsWith(path, '?') ? path.substr(0, path.length - 1) : path;
};
exports.buildWithQueryString = function (schemeDomainAndPath, queryString) {
    if (!queryString) {
        return schemeDomainAndPath;
    }
    return exports.canonicalizePath(schemeDomainAndPath) + "?" + exports.canonicalizeQueryString(queryString);
};
